module.exports = __webpack_public_path__ + "img/scienceTeacher.4175be92.webp";